import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.feature-sets.po-bill-to-defaults-view`

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Bill to',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage:
      'Manually created POs start with these settings, but purchasers can change them before submitting. Automatic POs use them as-is.',
  },
  punchoutNote: {
    id: `${scope}.punchoutNote`,
    defaultMessage:
      'PunchOut POs are set up separately on each PunchOut group.',
  },
})
